module.exports = __webpack_public_path__ + "static/img/produce-tp.97be8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/produce-tp.png
// module id = IGAT
// module chunks = 34